<template>
  <div>
    <KeepAlive>
      <VideoAlert
        v-if="mediaKeySelected?.split('-')[0] === 'video'"
        ref="videoAlertRef"
        :key="mediaKeySelected"
        :channel="Number(mediaKeySelected.split('-')[1])"
        :camera="getCameraByCalcChannel(mediaKeySelected.split('-')[1])"
        :check-is-dms-adas="checkIsDmsAdas"
        :vehicle-id-cam="vehicleIdCam"
        :imei-cam="imeiCam"
        :video-url="listMediaMap[mediaKeySelected]?.url"
        :media-filename="listMediaMap[mediaKeySelected]?.mediaFilename"
        :alert-code="alertCode"
        :status-dvh="listMediaMap[mediaKeySelected]?.status"
        :device-type="deviceType"
        :raw-alert-created-on="rawAlertCreatedOn"
        :raw-alert-id="rawAlertId"
        :isConnectingRequest="mediaMapConnecting[mediaKeySelected]"
        :show-tooltip-label-camera="true"
        :is-new-request-ui="true"
        @startConnectingRequest="startConnectingRequestVideo"
        @endConnectingRequest="endConnectingRequestVideo"
        @play-state-change="handleVideoPlayStateChange(mediaKeySelected, $event)"
        @no-video="handleNoVideo"
      />
      <ImageCapture
        v-if="mediaKeySelected?.split('-')[0] === 'image'"
        ref="imageCaptureRef"
        :key="mediaKeySelected"
        :channel="Number(mediaKeySelected.split('-')[1])"
        :camera="getCameraByCalcChannel(mediaKeySelected.split('-')[1])"
        :vehicle-id-cam="vehicleIdCam"
        :imei-cam="imeiCam"
        :raw-alert-id="rawAlertId"
        :media-filename="listMediaMap[mediaKeySelected]?.mediaFilename"
        :image-url="
          listMediaMap[mediaKeySelected]?.previewUrl || listMediaMap[mediaKeySelected]?.url
        "
        :is-generating-preview="mediaPreviewLoadingMap[mediaKeySelected] || false"
        :raw-alert-created-on="rawAlertCreatedOn"
        :status-dvh="listMediaMap[mediaKeySelected]?.status"
        :isConnectingRequest="mediaMapConnecting[mediaKeySelected]"
        :alert-code="alertCode"
        :can-request-image="deviceType === 'bsj' || deviceType === 'vss-howen'"
        :show-tooltip-label-camera="true"
        :device-type="deviceType"
        :is-demo="isSalesDemo"
        @startConnectingRequest="startConnectingRequestImage"
        @endConnectingRequest="endConnectingRequestImage"
        @no-image="handleNoImage"
      />
    </KeepAlive>
    <div class="mc-modal-alert-media__list-media-wrapper">
      <Thumbnail
        v-for="key in Object.keys(listMediaMap)"
        :key="key"
        :channel="Number(key.split('-')[1])"
        :media-type="key.split('-')[0]"
        :camera="getCameraByCalcChannel(key.split('-')[1])"
        :media-url="listMediaMap[key]?.previewUrl || listMediaMap[key]?.url"
        :thumbnail-state="calculatedState(key)"
        :is-selected="key === mediaKeySelected"
        :is-playing="mediaPlayingMap[key] || false"
        :is-generating-preview="mediaPreviewLoadingMap[key] || false"
        :media-key="key"
        :request-disabled="isMoreThan3Days"
        @clickThumbnail="clickThumbnail"
        @clickRequestMedia="clickRequestMedia"
      />
    </div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import VideoAlert from '../VideoAlert/index.vue'
import ImageCapture from '../ImageCapture/index.vue'
import Thumbnail from './Thumbnail.vue'
import moment from 'moment'
moment.locale('id')

export default {
  components: { VideoAlert, Thumbnail, ImageCapture },
  mixins: [Helper],
  props: {
    statusText: {
      required: true,
      type: String,
    },
    dvhData: {
      required: true,
      type: Array,
    },
    deviceType: {
      required: true,
      type: String,
    },
    vehicleIdCam: {
      required: true,
      type: Number,
    },
    imeiCam: {
      required: true,
      type: String,
    },
    alertCode: {
      type: Number,
      required: true,
    },
    rawAlertId: {
      type: Number,
      required: true,
    },
    rawAlertCreatedOn: {
      type: String,
      required: false,
      default: '',
    },
    checkIsDmsAdas: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      mediaKeySelected: null,
      listMediaMap: {}, // key is ${'image'|'video'}-${channel}
      mediaMapConnecting: {}, // key is ${'image'|'video'}-${channel}
      mediaPlayingMap: {}, // key is ${'image'|'video'}-${channel}
      mediaPreviewLoadingMap: {}, // key is ${'image'|'video'}-${channel}
      noVideoState: JSON.parse(localStorage.getItem('notification-no-video')) ?? [],
      noImageState: JSON.parse(localStorage.getItem('notification-no-image')) ?? [],
    }
  },
  computed: {
    isMoreThan3Days() {
      if (!this.rawAlertCreatedOn) return false
      return moment(this.rawAlertCreatedOn).isBefore(moment().subtract(3, 'days'))
    },
    getCameraByCalcChannel() {
      return (calcCh) => {
        return (
          this.statusText.split(',').findIndex((ch) => {
            if (this.deviceType === 'jc') return Number(ch) + 1 === Number(calcCh)
            return Number(ch) === Number(calcCh)
          }) + 1
        )
      }
    },
    calculatedState() {
      return (key) => {
        const mediaType = key.split('-')[0]
        const channel = Number(key.split('-')[1])

        if (
          (mediaType === 'video' && this.isNoVideoByState(channel)) ||
          (mediaType === 'image' && this.isNoImageByState(channel))
        )
          return 'no-media'

        if (this.deviceType === 'jc' && key.startsWith('image-')) {
          if (!this.listMediaMap[key]) return 'no-media'
          if (this.listMediaMap[key]?.status === 'F') return 'no-media'
        }

        if (this.mediaMapConnecting[key]) return 'processing'
        if (!this.listMediaMap[key]) return 'request-media'
        const data = this.listMediaMap[key]
        if (data.status === 'F') return 'request-media'
        if (data.status === 'I') return 'processing'
        if (data.status === 'S') return 'has-media'
        return null
      }
    },
    dataRequested() {
      return this.$store.state.notification.dataDvhRequested.filter((d) => {
        return d.rawAlertId
          ? String(d.rawAlertId) === String(this.rawAlertId)
          : new Date(d.startTime).getTime() === new Date(this.rawAlertCreatedOn).getTime()
      })
    },
    calculatedDvhData() {
      return [...this.dvhData, ...this.dataRequested]
    },
    isSalesDemo() {
      return this.$store.state.notification.detailNotification?.isDemo
    },
  },
  watch: {
    async '$store.state.notification.dataDvhRequested'(_dataRequested) {
      await this.$nextTick()
      this.setListMedia()
    },
    dvhData: {
      async handler() {
        await this.$nextTick()
        this.setListMedia()
      },
      deep: true,
    },
  },
  async mounted() {
    this.setListMedia()
    await this.$nextTick()
    this.setDefaultMediaKeySelected()
  },
  methods: {
    isNoVideoByState(channel) {
      return this.noVideoState.some(
        (item) => item.rawAlertId === this.rawAlertId && Number(item.channel) === Number(channel)
      )
    },
    isNoImageByState(channel) {
      return this.noImageState.some(
        (item) => item.rawAlertId === this.rawAlertId && Number(item.channel) === Number(channel)
      )
    },
    handleNoVideo(_payload) {
      this.noVideoState = JSON.parse(localStorage.getItem('notification-no-video')) ?? []
    },
    handleNoImage(_payload) {
      this.noImageState = JSON.parse(localStorage.getItem('notification-no-image')) ?? []
    },
    setDefaultMediaKeySelected() {
      let keySelected = Object.keys(this.listMediaMap)[0]

      const keyVideoS = [],
        keyImageS = [],
        keyVideoI = [],
        keyImageI = []

      Object.keys(this.listMediaMap).forEach((key) => {
        if (!this.listMediaMap[key]) return
        if (key.startsWith('video-') && this.listMediaMap[key].status === 'S') {
          keyVideoS.push(key)
        }
        if (key.startsWith('image-') && this.listMediaMap[key].status === 'S') {
          keyImageS.push(key)
        }
        if (key.startsWith('video-') && this.listMediaMap[key].status === 'I') {
          keyVideoI.push(key)
        }
        if (key.startsWith('image-') && this.listMediaMap[key].status === 'I') {
          keyImageI.push(key)
        }
      })

      if (keyVideoS.length) keySelected = keyVideoS[0]
      else if (keyImageS.length) keySelected = keyImageS[0]
      else if (keyVideoI.length) keySelected = keyVideoI[0]
      else if (keyImageI.length) keySelected = keyImageI[0]

      this.mediaKeySelected = keySelected
    },
    startConnectingRequestVideo(vehicleIdCam, channel) {
      this.$set(this.mediaMapConnecting, 'video-' + channel, true)
    },
    endConnectingRequestVideo(vehicleIdCam, channel) {
      this.$set(this.mediaMapConnecting, 'video-' + channel, false)
    },
    startConnectingRequestImage(vehicleIdCam, channel) {
      this.$set(this.mediaMapConnecting, 'image-' + channel, true)
    },
    endConnectingRequestImage(vehicleIdCam, channel) {
      this.$set(this.mediaMapConnecting, 'image-' + channel, false)
    },
    getVideoLengthInSeconds(startTime, endTime) {
      return Math.abs(moment.duration(moment(startTime).diff(moment(endTime))).asSeconds())
    },
    async clickThumbnail(key) {
      if (key === this.mediaKeySelected && key.startsWith('video-')) {
        if (this.mediaPlayingMap[key]) {
          this.setPlayVideo(false)
        } else {
          this.setPlayVideo(true)
        }
        return
      } else {
        this.handleChangeThumbnail(key)
      }
    },
    async handleChangeThumbnail(key) {
      if (
        this.mediaKeySelected.startsWith('video-') &&
        this.listMediaMap[this.mediaKeySelected] &&
        this.listMediaMap[this.mediaKeySelected].status === 'S' &&
        this.mediaPlayingMap[this.mediaKeySelected]
      ) {
        this.setPlayVideo(false)
      }
      await this.$nextTick()
      this.mediaKeySelected = key
      await this.delay(250)
      if (
        this.mediaKeySelected.startsWith('video-') &&
        this.listMediaMap[this.mediaKeySelected] &&
        this.listMediaMap[this.mediaKeySelected].status === 'S'
      ) {
        this.setPlayVideo(true)
      }
    },
    handleVideoPlayStateChange(key, isPlaying) {
      if (!key) return
      this.$set(this.mediaPlayingMap, key, isPlaying)
    },
    setPlayVideo(isPlay) {
      if (!this.mediaKeySelected) return
      if (isPlay) {
        this.$refs.videoAlertRef.$refs.videoShowRef.playVideo()
      } else {
        this.$refs.videoAlertRef.$refs.videoShowRef.pauseVideo()
      }
    },
    async clickRequestMedia(key) {
      const mediaType = key.split('-')[0]
      this.clickThumbnail(key)
      await this.delay(250)
      if (mediaType === 'video') {
        this.$refs.videoAlertRef.clickRequestVideo()
      } else if (mediaType === 'image') {
        this.$refs.imageCaptureRef.clickRequestPhoto()
      }
    },
    setListMedia() {
      const statusTextArr = this.statusText.split(',')
      statusTextArr.forEach((ch) => {
        const calcCh = this.deviceType === 'jc' ? Number(ch) + 1 : Number(ch)
        const dvh = this.calculatedDvhData.filter(
          (d) => d.channel === calcCh && (d.identifier === 'V' || d.identifier === 'R')
        )
        const dvhI = dvh.find((d) => d.status === 'I')
        const dvhF = dvh.find((d) => d.status === 'F')
        const dvhS = dvh.find((d) => d.status === 'S')
        this.$set(this.listMediaMap, `video-${calcCh}`, dvhS || dvhI || dvhF || null)
      })
      statusTextArr.forEach((ch) => {
        const calcCh = this.deviceType === 'jc' ? Number(ch) + 1 : Number(ch)
        const dvh = this.calculatedDvhData.filter((d) => {
          return (
            d.channel === calcCh &&
            (d.identifier === 'P' ||
              d.identifier === 'V' ||
              d.identifier === 'R' ||
              d.identifier === 'C')
          )
        })
        const dvhI = dvh.find((d) => d.status === 'I')
        const dvhF = dvh.find((d) => d.status === 'F')
        const dvhS = dvh.find((d) => d.status === 'S')
        this.$set(this.listMediaMap, `image-${calcCh}`, dvhS || dvhI || dvhF || null)
      })

      this.setPhotoFromVideoPreviewUrls()
    },

    isPhotoFromCaptureVideo(media) {
      if (!media) return false
      return media.identifier === 'C' && media.status === 'S'
    },

    async setPhotoFromVideoPreviewUrls() {
      const entries = Object.entries(this.listMediaMap).filter(
        ([key, media]) =>
          key.startsWith('image-') &&
          !!media &&
          media.status === 'S' &&
          (media.identifier === 'V' || media.identifier === 'R' || media.identifier === 'C')
      )

      await Promise.all(
        entries.map(async ([key, dvh]) => {
          if (dvh.previewUrl) return

          const filename = dvh.mediaFilename
          const isTsVideo = filename?.toLowerCase().endsWith('.ts')

          this.$set(this.mediaPreviewLoadingMap, key, true)

          try {
            const previewUrl = isTsVideo
              ? await this.generatePictureUrlFromTsVideo(dvh.url, {
                  frame: this.isPhotoFromCaptureVideo(dvh) ? 'start' : 'middle',
                  outputType: 'image/jpeg',
                })
              : await this.generatePictureUrlFromVideo(dvh.url, {
                  frame: this.isPhotoFromCaptureVideo(dvh) ? 'start' : 'middle',
                  fetchAsBlob: true,
                  outputType: 'image/jpeg',
                })

            const arrMediaFilename = dvh.mediaFilename.split('.')
            arrMediaFilename[arrMediaFilename.length - 1] = 'jpg'
            const mediaFilename = arrMediaFilename.join('.')
            if (previewUrl) {
              this.$set(this.listMediaMap, key, {
                ...dvh,
                previewUrl,
                mediaFilename,
                isPhotoFromVideo: true,
              })
            }
          } finally {
            this.$set(this.mediaPreviewLoadingMap, key, false)
          }
        })
      )
    },

    async downloadPhotoFromVideoPreview() {
      const mediaList = Object.values(this.listMediaMap).filter((media) => media?.isPhotoFromVideo)

      for (const media of mediaList) {
        await this.delay(250)
        this.downloadFile(media.previewUrl, media.mediaFilename)
      }
    },
  },
}
</script>
